// extracted by mini-css-extract-plugin
export default {"svg":"SVGUtil_svg__lI95i"};